import get from 'lodash/fp/get';

export const launchSequence = get('launchSequence');
export const navigation = get('navigation');
export const currentUser = get('currentUser');
export const coach = get('coach');
export const metric = get('metric');
export const report = get('report');
export const client = get('client');
export const candidate = get('candidate');
export const network = get('network');
export const apiError = get('apiError');
export const auth = get('auth');
export const remoteConfig = get('remoteConfig');
export const testingOptions = get('testingOptions');
export const loading = get('loading');
export const autoLogin = get('autoLogin');
export const popover = get('popover');
export const search = get('search');
export const watchList = get('watchList');
export const myTeams = get('myTeams');
